<template>
  <aside class="col-12 col-sm-12 col-md-12 col-lg-4 theiaStickySidebar">
    <div class="stickysidebar">
      <div class="white-bg d-flex justify-content-start align-items-center availability">
        <div>
          <span class="icon-bg"><img class="img-fluid" alt="Icon" src="@/assets/img/icons/head-calendar.svg"></span>
        </div>
        <div>
          <h4>Availability</h4>
          <p class="mb-0">Check availability on your convenient time</p>
        </div>
      </div>
      <div class="white-bg book-court">
        <h4 class="border-bottom">Book A Court</h4>
        <h5 class="d-inline-block">Badminton Academy,</h5>
        <p class="d-inline-block"> available Now</p>
        <ul class="d-sm-flex align-items-center justify-content-evenly">
          <li>
            <h3 class="d-inline-block primary-text">$150</h3><span>/hr</span>
            <p>up to 1 guests</p>
          </li>
          <li>
            <span><i class="feather-plus"></i></span>
          </li>
          <li>
            <h4 class="d-inline-block primary-text">$5</h4><span>/hr</span>
            <p>each additional guest <br>up to 4 guests max</p>
          </li>
        </ul>
        <div class="d-grid btn-block mt-3">
          <router-link to="/coaches/coach-details"
            class="btn btn-secondary d-inline-flex justify-content-center align-items-center"><i
              class="feather-calendar"></i>Book Now</router-link>
        </div>
      </div>
      <div class="white-bg">
        <h4 class="border-bottom">Request for Availability</h4>
        <form>
          <div class="mb-10">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" placeholder="Enter Name">
          </div>
          <div class="mb-10">
            <label for="email" class="form-label">Email</label>
            <input type="email" class="form-control" id="email" placeholder="Enter Email Address">
          </div>
          <div class="mb-10">
            <label for="name" class="form-label">Phone Number</label>
            <input type="text" class="form-control" id="phonenumber" placeholder="Enter Phone Number">
          </div>
          <div class="mb-10">
            <label for="date" class="form-label">Date</label>
            <div class="form-icon">
              <!-- <input type="text" class="form-control datetimepicker" placeholder="Select Date" id="date"> -->
              <datepicker
                v-model="startdate"
                class="form-control datetimepicker"
                :editable="true"
                :clearable="false"
                placeholder="Select Date"
                :input-format="dateFormat"
              />
              <span class="cus-icon">
                <i class="feather-calendar"></i>
              </span>
            </div>
          </div>
          <div class="mb-10">
            <label for="comments" class="form-label">Details</label>
            <textarea class="form-control" id="comments" rows="3" placeholder="Enter Comments"></textarea>
          </div>
          <div class="">
            <label class="form-label">Number of Guests</label>
            <div class="input-group">
              <input type="number" class="form-control" value="1" readonly>
              <input type="number" class="form-control active" value="2" readonly>
              <input type="number" class="form-control" value="3" readonly>
              <input type="number" class="form-control" value="4" readonly>
            </div>
          </div>
          <div class="form-check d-flex justify-content-start align-items-center policy">
            <div class="d-inline-block">
              <input class="form-check-input" type="checkbox" value="" id="policy" checked>
            </div>
            <label class="form-check-label" for="policy">By clicking 'Send Request', I agree to Dreamsport Privacy Policy
              and Terms of Use</label>
          </div>
          <div class="d-grid btn-block">
            <a href="javascript:;" class="btn btn-secondary d-inline-flex justify-content-center align-items-center">Send
              Request<i class="feather-arrow-right-circle ms-1"></i></a>
          </div>
        </form>
      </div>
      <div class="white-bg cage-owner-info">
        <h4 class="border-bottom">Cage Owner Details</h4>
        <div class="d-flex justify-content-start align-items-center">
          <div class="profile-pic">
            <a href="javascript:void(0);"><img class="img-fluid" alt="User" src="@/assets/img/profiles/avatar-05.jpg"></a>
          </div>
          <div class="">
            <h5>Hendry Williams</h5>
            <div class="rating">
              <i class="fas fa-star filled"></i>
              <i class="fas fa-star filled"></i>
              <i class="fas fa-star filled"></i>
              <i class="fas fa-star filled"></i>
              <i class="fas fa-star filled"></i>
              <span class="">5.0</span>
              <span>(20 Reviews)</span>
            </div>
          </div>
        </div>
        <div class="d-grid btn-block text-center mt-3">
          <router-link to="/contact-us" class="btn btn-secondary d-inline-flex justify-content-center align-items-center"><i
              class="feather-phone-call"></i>Call Owner</router-link>
        </div>
      </div>
      <div class="white-bg listing-owner">
        <h4 class="border-bottom">Listing By Owner</h4>
        <ul>
          <li class="d-flex justify-content-start align-items-center">
            <div class="">
              <router-link to="/blog/blog-details"><img class="img-fluid" alt="Venue" src="@/assets/img/listing-by-owner-01.jpg"></router-link>
            </div>
            <div class="owner-info">
              <h5><router-link to="/blog/blog-details">Manchester Academy</router-link></h5>
              <p><i class="feather-map-pin"></i><span>Sacramento, CA</span></p>
              <p class="mb-0"><i class="feather-calendar"></i><span>Next Availablity : </span><span
                  class="primary-text">15 May 2023</span></p>
            </div>
          </li>
          <li class="d-flex justify-content-start align-items-center">
            <div class="">
              <router-link to="/blog/blog-details"><img class="img-fluid" alt="Venue" src="@/assets/img/listing-by-owner-02.jpg"></router-link>
            </div>
            <div class="owner-info">
              <h5><router-link to="/blog/blog-details">Sarah Sports Academy</router-link></h5>
              <p><i class="feather-map-pin"></i><span>Sacramento, CA</span></p>
              <p class="mb-0"><i class="feather-calendar"></i><span>Next Availablity : </span><span
                  class="primary-text">15 May 2023</span></p>
            </div>
          </li>
        </ul>
      </div>
      <div class="white-bg">
        <h4 class="border-bottom">Share Venue</h4>
        <ul class="social-medias d-flex">
          <li class="facebook"><a href="javascript:void(0);"><i class="fa-brands fa-facebook-f"></i></a></li>
          <li class="instagram"><a href="javascript:void(0);"><i class="fa-brands fa-instagram"></i></a></li>
          <li class="behance"><a href="javascript:void(0);"><i class="fa-brands fa-behance"></i></a></li>
          <li class="twitter"><a href="javascript:void(0);"><i class="fa-brands fa-twitter"></i></a></li>
          <li class="pinterest"><a href="javascript:void(0);"><i class="fa-brands fa-pinterest"></i></a></li>
          <li class="linkedin"><a href="javascript:void(0);"><i class="fa-brands fa-linkedin"></i></a></li>
        </ul>
      </div>
    </div>
  </aside>
</template>

<script>
import { ref } from "vue";
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
    }
  },
}
</script>